module.exports = __webpack_public_path__ + "static/img/search-new.d6d15cb2.svg";